<template>
  <div id="app">
    <!-- <div class="loading">LOGO</div> -->
    <transition name="slide-fade">
      <router-view/>
    </transition>
    <navs/>
    <player></player>
  </div>
</template>

<script>
// import 'bootstrap/dist/css/bootstrap.css'
import navs from '@/components/nav'
import player from '@/components/player'
export default {
  name: 'App',
  components: {
    navs,
    player
  },
  data() {
    return {
      url: ''
    }
  },
  created() {
    // document.body.scrollTop = 0
    // $(window).scrollTop(0)
    $(window).scrollTop(0)
    // $('html,body').animate({ scrollTop: 0 }, 400);
  },
  mounted() {
    $(function() {
      // $(".loading").css("display","none");
    })
  }
}
</script>

<style lang="scss" scoped>
@import './assets/scss/color.scss';
@import './assets/scss/ly.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
img {
  width: 100px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  // transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue